// extracted by mini-css-extract-plugin
export default {"Images__deleteButton":"styles_Images__deleteButton__Wmd4L","Images__image":"styles_Images__image__qcInT"};